import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ApplicationClientCommonModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { DictionaryModule } from '@sdbn/common';

import { TmcYardCommonModule } from '../../../common/common.module';
import { TransportTileListComponent } from './component/transport-tile-list/transport-tile-list.component';
import { TransportListModule as TransportListModuleNeu} from '../../../common/components/transport-list/transport-list.module'
import { TransportDetailsModule } from '../../../common/components/transport-details/transport-details.module';
import { TransportCountsComponent } from './component/transport-counts/transport-counts.component';
import { TransportOverviewComponent } from './component/transport-overview/transport-overview.component';

@NgModule({
  declarations: [
    TransportOverviewComponent,
    TransportTileListComponent,
    TransportCountsComponent
  ],
  imports: [
    CommonModule,
    DictionaryModule,

    TransportDetailsModule,
    ApplicationClientCommonModule,
    CommonTranslationModule,
    TmcYardCommonModule,
    TransportListModuleNeu
  ],
  exports: [
    TransportOverviewComponent,
    TransportTileListComponent
  ]
})
export class TransportListModule { }
